import useragent from '@common/useragent'
import dialog from '@common/dialog'

import { call, uriSuiguanjia } from './bridge'

const DOWNLOAD_IOS = 'https://itunes.apple.com/zh/app/id372353614?l=zh&ls=1&mt=8' // IOS下载地址
const DOWNLOAD_ANDRIOD = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.feidee.myfinance' // 应用宝地址

const isWeiXin = useragent.isWechat // 微信

/**
 * 下载提示窗
 * cancelCallback: 点击取消按钮的回调
 */
const fnDownloadApp = (cancelCallback) => {
  dialog({
    msg: '赶紧打开随管家APP使用哦~',
    confirmText: '立即打开',
    handleConfirm() {
      if (isWeiXin || !useragent.isIOS) {
        window.location.href = DOWNLOAD_ANDRIOD
      } else {
        window.location.href = DOWNLOAD_IOS
      }
    },
    handleCancel() {
      if (cancelCallback) {
        try {
          cancelCallback()
        } catch (e) {
          console.log(e)
        }
      }
    }
  })
}

/**
 * 唤醒随手记
 * url: 唤醒随手记后跳转的地址
 */
const evokeApp = (url, callback = () => {}) => {
  let uri
  const isHttpUrl = /(http:\/\/)|(https:\/\/)/g.test(url)
  if (isHttpUrl) {
    // 如果是http链接
    uri = uriSuiguanjia('sgj://launch.ssjlicai.com', {
      url
    }, 'onOpenSuccess')
  } else {
    uri = uriSuiguanjia('sgj://launch.ssjlicai.com', {
      p: url,
    }, 'onOpenSuccess')
  }
  call(uri, 'onOpenSuccess', callback)
}

/**
 * 唤醒方法
 * url: 唤醒APP后跳转的页面地址,默认为当前页面
 */
export const open = (url = window.location.href) => {
  const timerTask = setTimeout(fnDownloadApp, 600)
  evokeApp(url, () => {
    console.log('openfn callback has run')
    window.clearTimeout(timerTask)
  })
}

export default open



// WEBPACK FOOTER //
// ./node_modules/@common/client/src/openSuiguanjia.js